module.exports = __webpack_public_path__ + "static/media/12.31ce83b5.gif";